import flatpickr from 'flatpickr';

const ScheduleForm = () => {
  const init = () => {
    flatpickr('#preferred-showing-date', {
      altInput: true,
      altFormat: 'F j, Y',
      dateFormat: 'Y-m-d',
      defaultDate: new Date(),
      minDate: new Date(),
      ariaDateFormat: 'Y-m-d',
      showMonths: 2,
    });
  };

  return {
    init,
  };
};

export default ScheduleForm;
